import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function WarningFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14.6753 3.80328C13.4774 1.73224 10.5216 1.73224 9.32365 3.80328L1.67844 17.0209C0.478187 19.096 1.93644 21.75 4.35427 21.75H19.6447C22.0625 21.75 23.5208 19.096 22.3205 17.0209L14.6753 3.80328ZM11 17C11 16.4477 11.4477 16 12 16C12.5523 16 13.009 16.4477 13.009 17C13.009 17.5523 12.5613 18 12.009 18C11.4567 18 11 17.5523 11 17ZM13 9C13 8.44772 12.5523 8 12 8C11.4477 8 11 8.44772 11 9V14C11 14.5523 11.4477 15 12 15C12.5523 15 13 14.5523 13 14V9Z"
				fill="currentColor"
			/>
		</svg>
	);
}

WarningFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default WarningFilledIcon;
